import { css } from '@emotion/react';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { commonMessages } from '../../../i18n/commonMessages';
import { styled } from '../../../styled';
import type { Theme } from '../../../theme/interface/detailed';
import { isMobile } from '../../../utils/isMobile';

type Interface = { className: string };

const Component = ({ className }: Interface): ReactElement => {
	const { formatMessage } = useIntl();
	return <div className={className}>{formatMessage(commonMessages.chat)}</div>;
};

const OfflineChatGratitudeHeader = styled(Component)(
	({
		theme: {
			offlineChat: {
				header: { offlinePrechatHeader },
			},
		},
	}: {
		theme: Theme;
	}) => offlinePrechatHeader,
	css`
		display: flex;
		flex-direction: column;
		grid-gap: 4px;
		font-weight: bold;

		& > div {
			${isMobile ? 'padding: 0 20px' : ''}
		}
	`
);

export { OfflineChatGratitudeHeader };
